import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';
import { PlatonAppModuleNgFactory } from '../../app.module.ngfactory';

export function ProdConfig() {
    enableProdMode();
    platformBrowser().bootstrapModuleFactory(PlatonAppModuleNgFactory);
}



// WEBPACK FOOTER //
// ./src/app/blocks/config/prod.config.ts